
const privacyBody = `**1. Responsável pelo tratamento / Verantwortlicher**

[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa]
E-Mail: bringylatam@gmail.com

**2. Dados que recolhemos**

Quando utiliza o formulário de contacto deste site, recolhemos os seguintes dados: nome, endereço de correio eletrónico, rota de interesse e a mensagem que nos envia. Estes dados são necessários para lhe respondermos.

O site pode armazenar cookies técnicos estritamente necessários ao funcionamento básico. Não utilizamos cookies de rastreio nem publicidade de terceiros.

**3. Finalidade do tratamento**

Os dados do formulário são utilizados exclusivamente para responder à sua consulta e gerir o seu registo inicial na plataforma. Não são cedidos a terceiros sem o seu consentimento, salvo obrigação legal.

**4. Fundamento jurídico**

O tratamento baseia-se no seu consentimento (Art.º 6.º, n.º 1, alínea a), RGPD), ao enviar o formulário, e no interesse legítimo de gerir a relação pré-contratual (Art.º 6.º, n.º 1, alínea b), RGPD).

**5. Conservação dos dados**

Os dados do formulário de contacto conservam-se durante o tempo necessário para tratar o seu pedido e, no máximo, 12 meses desde o último contacto, salvo se uma relação contratual posterior exigir período mais longo.

**6. Os seus direitos**

Tem direito a: aceder aos seus dados pessoais, solicitar a sua retificação ou eliminação, opor-se ao tratamento, solicitar a portabilidade dos dados e apresentar reclamação à autoridade de proteção de dados competente.

Para exercer os seus direitos, escreva-nos para: bringylatam@gmail.com

**7. Alojamento**

Este site está alojado na Cloudflare. A Cloudflare pode processar dados técnicos de acesso (endereço IP, navegador, data e hora) como parte do seu serviço de rede e segurança. Mais informações: https://www.cloudflare.com/privacypolicy/

**8. Alterações a esta política**

Podemos atualizar esta política a qualquer momento. A versão em vigor estará sempre disponível nesta página com a data da última atualização.`

const impressumBody = `Informações nos termos do § 5 TMG / Información según § 5 TMG

**Responsável / Responsable:**
[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa — calle, número, código postal, ciudad, país]

**Contacto / Contact:**
E-Mail: bringylatam@gmail.com
Telefone / Teléfono: [COMPLETAR: +49 ... o número correspondiente]

**Operador da plataforma:**
Bringy
[COMPLETAR: misma dirección legal]

**NIF-IVA / identificação fiscal (se aplicável):**
[COMPLETAR: DE... o número fiscal del país de registro]

**Aviso de responsabilidade:**
A Bringy atua como plataforma intermediária entre compradores e viajantes. Não somos parte contratante nas transações entre utilizadores nem assumimos responsabilidade pelos produtos trocados, salvo nos casos expressamente previstos nos nossos Termos de Utilização.

As informações deste website foram compiladas com cuidado; contudo não garantimos a sua exatidão, integridade ou atualidade.

**Resolução de litígios:**
A Comissão Europeia disponibiliza uma plataforma de resolução de litígios em linha (RLL): https://ec.europa.eu/consumers/odr
Não estamos dispostos nem obrigados a participar em procedimentos de resolução de litígios perante uma entidade de arbitragem do consumidor.`

export const pt = {
  brand: {
    name: 'Bringy',
    tagline: 'Pessoas reais. Produtos reais. Rotas verificadas.',
  },
  nav: {
    howItWorks: 'Como funciona',
    whyUs: 'Porquê Bringy',
    offerings: 'Serviços',
    faq: 'FAQ',
    contact: 'Contacto',
    cta: 'Começar',
  },
  hero: {
    eyebrow: 'Europa ↔ América do Sul',
    titleAccent: 'Bring',
    titleRest: 'O que importa.',
    subtitle:
      'Ligamos pessoas que viajam entre a Europa e a América do Sul a quem precisa de produtos do outro lado. Sem estafeta, sem agência — apenas pessoas reais com identidade verificada.',
    ctaBuscar: 'Procurar um produto',
    ctaOfrecer: 'Oferecer como viajante',
    trustBadges: [
      { label: 'Identidade verificada' },
      { label: 'Pagamento em escrow' },
      { label: 'Pontuação pública do viajante' },
      { label: 'Entrega documentada' },
    ],
    boardingPass: {
      passengerLabel: 'PASSAGEIRO',
      brand: 'BRINGY',
      sub: 'TRANSPORTE · VERIFICADO · SEGURADO',
      fromCode: 'BER',
      fromCity: 'BERLIM',
      toCode: 'EZE',
      toCity: 'BUENOS AIRES',
      flight: 'VOO BR · 2026',
      gate: 'PORTÃO A7',
    },
    coordsBerlin: '52.52°N · 13.40°E',
    coordsBuenosAires: '34.60°S · 58.38°W',
  },
  launchTrust: {
    id: 'lanzamiento',
    launchNote:
      'A Bringy está em fase de lançamento. Cada novo viajante é verificado pessoalmente pela nossa equipa.',
    processTitle: 'Antes de um viajante transportar um único artigo',
    processIntro:
      'Mostramos o rigor do processo — não testemunhos inventados. Assim construímos confiança desde o primeiro dia.',
    stepVerified: 'Verificado',
    stepPending: 'Pendente',
    processSteps: [
      {
        number: '01',
        title: 'Verificação de identidade',
        description: 'Documento oficial validado antes de operar na plataforma.',
      },
      {
        number: '02',
        title: 'Integração por vide chamada',
        description: 'Conversa inicial com a nossa equipa para explicar regras e expectativas.',
      },
      {
        number: '03',
        title: 'Acordo de escrow',
        description: 'Aceitação dos termos de pagamento protegido antes da primeira transação.',
      },
    ],
    foundingMembers: '{count} viajantes já registaram a sua primeira rota',
  },
  whyUs: {
    id: 'por-que',
    sectionLabel: '02 · Porquê Bringy',
    headline: 'Quatro garantias.',
    headlineAccent: 'Sem exceções.',
    title: 'Porque a Bringy funciona',
    subtitle:
      'As soluções informais já existem — grupos de WhatsApp, contactos de contactos. A Bringy faz o mesmo, com a infraestrutura que faltava.',
    cardAirline: 'BR · 2026',
    cardConfirmed: 'CONFIRMADO',
    cardPending: 'PENDENTE',
    cardApproved: '· APROVADO ·',
    cardsMeta: [
      { value: 'IDENTIDADE', field: 'KYC · PASSAPORTE' },
      { value: 'SEGURO', field: 'ATÉ €4.000' },
      { value: 'CONFORMIDADE', field: 'EU · AR · DECLARADO' },
      { value: 'ENTREGA', field: 'FOTO · RASTREADO' },
    ],
    items: [
      {
        title: 'Confiança verificada',
        description:
          'Cada viajante passa por verificação de identidade antes de operar na plataforma. Sabe com quem está a lidar.',
      },
      {
        title: 'O seu dinheiro, protegido',
        description:
          'Os fundos ficam em escrow até confirmar a receção do produto. Sem risco de pagar por algo que não chega.',
      },
      {
        title: 'Reputação real',
        description:
          'Cada viajante acumula histórico de entregas e avaliações. Pode ver a pontuação antes de coordenar.',
      },
      {
        title: 'Entrega documentada',
        description:
          'Para maior segurança, oferecemos verificação em direto com um representante Bringy por vide chamada.',
      },
    ],
  },
  services: {
    id: 'como-funciona',
    sectionLabel: '03 · Como funciona',
    headline: 'Uma pista, não',
    headlineAccent: 'um processo.',
    tagline: 'Quatro passos. Uma travessia do Atlântico.',
    title: 'Como funciona',
    subtitle: '',
    footerLabels: { status: 'ESTADO', eta: 'ETA', lane: 'FAIXA' },
    stepMeta: [
      { status: 'EM ESPERA', eta: '~ 18H', lane: 'A7' },
      { status: 'EM ESPERA', eta: '~ 36H', lane: 'B8' },
      { status: 'EM ESPERA', eta: '~ 54H', lane: 'C9' },
      { status: 'EM ESPERA', eta: '~ 72H', lane: 'D10' },
    ],
    steps: [
      {
        number: 1,
        title: 'Publique o seu pedido',
        description:
          'Descreva o produto de que precisa, o destino e o que oferece pelo serviço de transporte.',
      },
      {
        number: 2,
        title: 'Um viajante aceita',
        description:
          'Viajantes verificados com rotas ativas veem o seu pedido e oferecem-se para o levar na próxima viagem.',
      },
      {
        number: 3,
        title: 'Coordenam os pormenores',
        description:
          'Acordam a forma de pagamento, o ponto de entrega e os prazos diretamente com o viajante no chat da plataforma.',
      },
      {
        number: 4,
        title: 'Recebe e confirma',
        description:
          'Quando tem o produto, confirma a entrega e o pagamento é libertado para o viajante.',
      },
    ],
  },
  manifest: {
    sectionLabel: '04 · Manifesto de hoje',
    headline: 'O painel,',
    headlineAccent: 'ao vivo.',
    tagline: 'Todos os envios declarados.',
    liveLabel: 'Ao vivo · {count} envios hoje',
    columns: ['Hora', 'De → Para', 'Envio', 'Estado', 'Portão'],
    rows: [
      { time: '02:14', from: 'BER', to: 'EZE', carry: 'MEDICAMENTOS', status: 'SEGURADO', gate: 'A07', statusKey: 'insured' },
      { time: '06:40', from: 'MAD', to: 'EZE', carry: 'ELECTRÓNICA', status: 'VERIFICADO', gate: 'B12', statusKey: 'verified' },
      { time: '09:25', from: 'FCO', to: 'EZE', carry: 'CALÇADO', status: 'EMBARQUE', gate: 'C04', statusKey: 'boarding' },
      { time: '11:55', from: 'CDG', to: 'EZE', carry: 'DOCUMENTOS', status: 'SEGURADO', gate: 'D21', statusKey: 'insured' },
      { time: '14:30', from: 'LIS', to: 'EZE', carry: 'LIVROS', status: 'EMPARELHADO', gate: 'A03', statusKey: 'matched' },
    ],
    footerLeft: 'EU → AR · Manifesto 2026',
    footerRight: 'Pré-lançamento · Rotas verificadas',
  },
  activeRoutes: {
    sectionLabel: '05 · Rotas ativas',
    headline: 'A Europa parte.',
    headlineAccent: 'Buenos Aires espera.',
    tagline: 'Cinco corredores. Uma direção. Só transportamos o que alguém já vai levar.',
    routePrefix: 'ROTA',
    originLabel: 'Origem',
    destLabel: 'Destino',
    flightLabel: 'Voo',
    openLabel: 'Aberto',
    routes: [
      { fromCity: 'Berlim',  fromCode: 'BER', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Madrid',  fromCode: 'MAD', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h' },
      { fromCity: 'Roma',    fromCode: 'FCO', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Paris',   fromCode: 'CDG', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h 30m' },
      { fromCity: 'Lisboa',  fromCode: 'LIS', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 12h 20m' },
    ],
  },
  offerings: {
    id: 'servicios',
    sectionLabel: '06 · Serviços',
    title: 'Serviços',
    buyer: {
      label: 'Para compradores',
      title: 'Encontre o que não chega ao seu país',
      body: 'Publique o que precisa e ligue-se a um viajante verificado que já faz a viagem. Aceda a produtos a preços de origem, sem intermediários.',
      cta: 'Publicar um pedido',
      products: [
        { name: 'iPhone 17 Pro · 256GB', price: '€ 980', route: 'Madrid → Buenos Aires', image: 'products/iPhone_17_Pro_Cosmic_Orange_PDP_Image_Position_1__DEDE-l.webp', imageAlt: 'iPhone 17 Pro' },
        { name: 'Nike Air Max 90', price: '€ 140', route: 'Berlim → Buenos Aires', image: 'products/nike.webp', imageAlt: 'Nike Air Max 90' },
        { name: 'PlayStation 5 Slim', price: '€ 480', route: 'Roma → Buenos Aires', image: 'products/sony-playstation-5-digital-edition-825-gb-wlan-schwarz-weiss.webp', imageAlt: 'PlayStation 5 Slim' },
        { name: 'Chanel Nº5 · 100ml', price: '€ 120', route: 'Paris → Buenos Aires', image: 'products/chanel-no-5-edp-vapo-200ml.png', imageAlt: 'Chanel Nº5' },
      ],
    },
    traveler: {
      label: 'Para viajantes',
      title: 'Monetize o espaço livre da sua bagagem',
      body: 'Viaja entre a Europa e a América do Sul? Publique a sua rota e os produtos que pode levar. Amorteça parte da viagem e construa reputação como viajante de confiança.',
      cta: 'Registar-me como viajante',
      routes: [
        { route: 'Berlim → Buenos Aires', activeTravelers: 'HQ · 3 viajantes ativos' },
        { route: 'Madrid → Buenos Aires', activeTravelers: '12 viajantes ativos' },
        { route: 'Roma → Buenos Aires', activeTravelers: '5 viajantes ativos' },
        { route: 'Paris → Buenos Aires', activeTravelers: '4 viajantes ativos' },
        { route: 'Lisboa → Buenos Aires', activeTravelers: '7 viajantes ativos' },
      ],
    },
  },
  faq: {
    id: 'faq',
    title: 'Perguntas frequentes',
    subtitle: '',
    items: [
      {
        question: 'Como me registo na Bringy?',
        answer:
          'Preencha o formulário com o seu nome, email e se quer comprar ou viajar. Contactamo-lo em 24 horas para o orientar nos primeiros passos.',
      },
      {
        question: 'Quem pode ser viajante?',
        answer:
          'Qualquer pessoa com mais de 18 anos que viaje regularmente entre a Europa e a América do Sul. É necessária verificação de identidade antes de publicar rotas ativas.',
      },
      {
        question: 'Como sei que o viajante é de confiança?',
        answer:
          'Cada viajante tem um perfil com nível de verificação, histórico de entregas e avaliações de outros utilizadores. Quanto mais histórico, maior a confiança.',
      },
      {
        question: 'O que acontece ao meu dinheiro se o produto não chegar?',
        answer:
          'Os fundos mantêm-se em escrow até confirmar a receção. Se houver problema, a equipa Bringy intervém e media entre as partes.',
      },
      {
        question: 'Que produtos posso pedir?',
        answer:
          'Qualquer produto legal que possa transportar-se na bagagem de cabine ou porão segundo as normas alfandegárias do país de destino. Eletrónica, roupa, cosmética, alimentos não perecíveis, documentos, entre outros.',
      },
      {
        question: 'Quanto cobra a Bringy?',
        answer:
          'Uma comissão de 8 a 10% sobre cada transação concluída. Viajantes frequentes podem aceder à subscrição Pro por 9 €/mês, que elimina a comissão e oferece maior visibilidade.',
      },
      {
        question: 'Posso pedir uma entrega com verificação em direto?',
        answer:
          'Sim. Para transações de maior valor ou quando ambas as partes preferem, um representante Bringy entra por vide chamada, verifica identidades e documenta a troca.',
      },
      {
        question: 'Em que rotas estão disponíveis?',
        answer:
          'Operamos rotas de Berlim (HQ), Madrid, Roma, Paris e Lisboa — todas com destino Buenos Aires. Acrescentamos novas rotas conforme a procura da comunidade.',
      },
      {
        question: 'Que meios de pagamento aceitam?',
        answer:
          'Cartões Visa, Mastercard e Amex. Stripe para pagamentos internacionais com cartão em qualquer país. Transferências SEPA na Europa. Mercado Pago na América do Sul. Libertação dos fundos em 1–2 dias úteis após confirmar a entrega.',
      },
    ],
  },
  globe: {
    cities: ['Berlim ★', 'Madrid', 'Roma', 'Paris', 'Lisboa', 'Buenos Aires'],
  },
  contact: {
    id: 'contacto',
    title: 'Tem uma pergunta ou quer juntar-se?',
    subtitle:
      'Estamos em fase de lançamento e queremos conhecer o seu caso. Preencha o formulário — um elemento da equipa entrará em contacto consigo nas próximas 24 horas.',
    emailLabel: 'Também pode escrever-nos para',
  },
  footer: {
    copyright: '© {year} Bringy. Todos os direitos reservados.',
    tagline: 'Pessoas reais. Produtos reais. Rotas verificadas.',
    hubBerlin: 'Berlim',
    hubBuenosAires: 'Buenos Aires',
    links: {
      howItWorks: 'Como funciona',
      whyUs: 'Porquê Bringy',
      offerings: 'Serviços',
      faq: 'Perguntas frequentes',
      contact: 'Contacto',
      impressum: 'Impressum',
      privacy: 'Política de privacidade',
    },
    social: {
      instagram: '@bringy',
      linkedin: 'linkedin.com/company/bringy',
      linkedinLabel: 'LinkedIn',
    },
    credits: {
      prefix: 'Feito por',
      studio: 'INKSKY independent studio',
    },
  },
  legal: {
    backHome: 'Voltar ao início',
    placeholderNotice:
      'Campos assinalados [COMPLETAR] pendentes da constituição da entidade jurídica.',
    privacy: {
      title: 'Política de privacidade',
      body: privacyBody,
    },
    terms: {
      title: 'Termos de utilização',
      body: 'A Bringy atua como plataforma intermediária entre compradores e viajantes. A utilização implica aceitação da verificação de identidade, transporte apenas de produtos legais e resolução de disputas segundo as condições da plataforma. Texto definitivo pendente de publicação.',
    },
    impressum: {
      title: 'Impressum',
      body: impressumBody,
    },
  },
  a11y: {
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    chooseLanguage: 'Escolher idioma',
  },
  forms: {
    backHome: 'Voltar ao início',
    submit: 'Enviar pedido',
    successTitle: 'Recebemos o seu pedido!',
    successBody:
      'Contactamo-lo nas próximas 24 horas para coordenar os pormenores. Bem-vindo/a à Bringy.',
    fields: {
      name: { label: 'Nome completo', placeholder: 'O seu nome completo' },
      email: { label: 'Email', placeholder: 'seu@email.com' },
      role: {
        label: 'Eu sou…',
        placeholder: 'Seleccione uma opção',
        buyer: 'Comprador',
        traveler: 'Viajante',
      },
      countryRoute: {
        label: 'Rota de interesse',
        placeholder: 'Ex.: Madrid → Buenos Aires',
        other: 'Outra rota',
      },
      message: {
        label: 'Produto ou mensagem',
        placeholder: 'Diga-nos que produto procura ou o que pode levar',
        optional: 'Opcional',
      },
    },
    errors: {
      required: 'Preencha este campo',
      email: 'Introduza um email válido',
      role: 'Seleccione uma opção',
      submitFailed: 'Não conseguimos enviar o formulário. Tente novamente.',
    },
    sending: 'A enviar…',
    privacyNote:
      'Ao enviar aceita que usemos estes dados para o contactar sobre a Bringy. Ver a nossa',
    defaultDescriptions: {
      requestItem: 'Consulta a partir do formulário de contacto',
      becomeTraveler: 'Registo de viajante a partir do formulário de contacto',
    },
    requestItem: {
      title: 'Procurar um produto',
      subtitle: 'Diga-nos o que precisa — contactamo-lo em 24 horas.',
    },
    becomeTraveler: {
      title: 'Oferecer como viajante',
      subtitle: 'Diga-nos a sua rota — contactamo-lo em 24 horas.',
    },
  },
}
